import React from "react";
import PropTypes from "prop-types";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import "./ButtonGroup.scss";

/**
 * ButtonGruop
 * @module
 * @param {array} data - Data of buttons
 * @param {string} textField - Name of text field
 * @param {object} [value] - Currently selected button
 * @param {func} onChange - Function invoked on button change
 * @param {string} name - Name of button group
 * @param {bool} [disabled] - Disabled button
 * @param {string} [iconField] - Name of icon field
 * @param {string} [dataItemKey] - Key of data item
 * @param {string} [className] - Classname of the button group
 */
const ButtonGroupComponent = (props) => {
  const onMouseOver = (e, button) => {
    e.target.title = button[props.textField];
  };

  const onClick = (e, button) => {
    e.preventDefault();
    if (Array.isArray(props.value)) {
      let value = [];
      if (
        props.value
          .map((button) => button[props.dataItemKey])
          .includes(button[props.dataItemKey])
      ) {
        value = props.value.filter(
          (v) => v[props.dataItemKey] !== button[props.dataItemKey]
        );
      } else {
        value = [...props.value, button];
      }
      props.onChange(props.name, value);
    } else {
      props.onChange(props.name, button);
    }
  };

  let primaryList = [];
  if (Array.isArray(props.value)) {
    primaryList = props.value.map((x) => x[props.dataItemKey]);
  } else if (props.value) {
    primaryList = [props.value].map((x) => x[props.dataItemKey]);
  }

  return (
    <ButtonGroup className="button-group">
      {props.data.map((button, index) => {
        return (
          <Button
            type="button"
            className={props.className}
            themeColor={
              primaryList.includes(button[props.dataItemKey]) ? "primary" : "base"
            }
            icon={button[props.iconField]}
            onClick={(e) => onClick(e, button)}
            onMouseOver={(e) => onMouseOver(e, button)}
            disabled={props.disabled || button.disabled}
            key={button[props.dataItemKey] || index}
            togglable={props.toggle}
            fillMode={"flat"}
          >
            {button[props.textField]}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

ButtonGroupComponent.propTypes = {
  data: PropTypes.array.isRequired,
  textField: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  iconField: PropTypes.string,
  dataItemKey: PropTypes.string,
  className: PropTypes.string,
  toggle: PropTypes.bool,
};

export default ButtonGroupComponent;
